import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "TV's are now computers O.o",
  "description": "",
  "published": "2011-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/tvs-are-now-computers-o-o/swizec/2918"],
  "categories": "Broadcasting, Television, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The television set I grew up with left our place yesterday. It's actually kind of odd, as my hometown has changed year to year, as I went to different schools, changed my computers, my tastes in culture, even most of the furniture I'm using ... the one thing that has always stayed the same was the family television set.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/tumblr_lummi415Um1qekjngo1_50010.jpg",
        "alt": "The old telly",
        "title": "The old telly"
      }}></img></p>
    <p>{`I still sort of remember the shopping trip when we brought it home with my dad. I must have been around four years old, which would make that TV around twenty years old now.`}</p>
    <p>{`Twenty long years.`}</p>
    <p>{`And now it's gone. It went quietly, without fanfare, nobody gave it two thoughts. As simple as moving a big lump of glass and electronics and plastic down four flights of stairs without a lift. For the last year you even had to use a toothpick to turn on our dear telly, and lately the image was all flickery and without colour.`}</p>
    <p>{`And then we plugged in the new one.`}</p>
    <p>{`Holy mother of god, what televisions have done in the past 20 years! That thing is a freaking computer!`}</p>
    <p>{`Hell, you have to politely ask it to recognise all manners of external devices, even the set-top-box needs to politely introduce itself! The menus and dials indicate that something as simple as a sound system needs a warm introduction as well.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/tumblr_lun8x9awgB1qekjngo1_5003.jpg",
        "alt": "Sexy new telly",
        "title": "Sexy new telly"
      }}></img></p>
    <p>{`Yep, that telly rules the living room and `}<em parentName="p">{`it knows it`}</em>{`. I'm sure whenever the television is off it sings `}<em parentName="p"><a parentName="em" {...{
          "href": "http://www.youtube.com/watch?v=wyx6JDQCslE&ob=av3e"
        }}>{`sexy and I know it`}</a></em>{` quietly in its own ear.`}</p>
    <p>{`The most technologically interesting bit I've found so far is the ethernet port on the back.`}</p>
    <p>{`Apparently you can connect the television (should I be calling this thing a stripped down computer?) to your home network and stream movies right from a computer - obvious choice here would be my linux box holding the collection of roughly 960GB of video ... why do I have that much again? Guess that happens when you have FTTH.`}</p>
    <p>{`There's problem with this epic feature though. The telly is still not a computer and can't just browse stuff on the network. Nope, needs something called a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/UPnP_AV_media_server",
        "title": "UPnP AV media server"
      }}>{`UPnP Media Server`}</a>{` to stream the files. Unfortunately, the internet is very scarce with information about this (or I suck at looking for it), but the best I've found so far is `}<a parentName="p" {...{
        "href": "http://mediatomb.cc/"
      }}>{`MediaTomb`}</a>{`.`}</p>
    <p>{`No luck so far getting the TV to recognise this server exists on the network and playing the files. Brilliant success playing HD movies from a portable disk though ...`}</p>
    <p>{`Another useful feature on these modern television set things is the internet. Sure, it's a stripped down internet reduced to a bunch of icons, sometimes called apps, that you can use discretly rather as a proper browser, but hey, when was the last time you watched youtube and vimeo videos on a telly?`}</p>
    <p>{`Or used facebook and twitter for that matter?`}</p>
    <p>{`There's probably some way to hack this, there's bound to be support for a real browser deep down in the bowels of this OS ... but I will restrain myself from looking for it. This is the family telly, not one of my computers and is not a playground.`}</p>
    <p>{`Oh and perhaps most surprising of all, the UX is `}<em parentName="p">{`good`}</em>{`.Up to par with, if not better than, with iOS. No joke. Philips knows what they're doing. I was highly surprised!`}</p>
    <p>{`Now if only Siol put a UX even remotely as good on their set-top-box I'm sure everyone would be a happy camper.`}</p>
    <p>{`edit: I just discovered that the telly does in fact have a full blown browser`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=f32cc307-9bfd-47c8-acb1-647a6808b08b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      